import type { Meta, StoryFn } from '@storybook/react';
import type { MetaDataListProps } from './MetaDataList';

import { MetaDataList } from './MetaDataList';

import { Container } from 'storyComponents/Container/';

const codeString = '<MetaDataList items={items} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/MetaDataList',
  component: MetaDataList,
  parameters: {
    inspectComponent: MetaDataList,
    codeString: codeString,
  },
} as Meta<MetaDataListProps>;

const Template: StoryFn<MetaDataListProps> = (args) => (
  <Container>
    <MetaDataList {...args} />
  </Container>
);

export const MetaDataListExample = Template.bind({});
MetaDataListExample.args = {
  items: {
    'item one': 'foo',
    'item two': 'bar',
    'item three': 'baz',
  },
};
